module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/events-screen/parent-events-row-details/parent-events-row-details.component.scss
// module id = ./src/app/admin/events-screen/parent-events-row-details/parent-events-row-details.component.scss
// module chunks = main